export const getEmailApiUrl = (path = '') => {
  const env =
    ((typeof process !== 'undefined' && process.env &&
      (process.env.APP_ENV || process.env.NODE_ENV)) || ''
    ).toLowerCase();

  const host = (typeof window !== 'undefined' && window.location?.hostname) || '';
  const isProd =
    env.startsWith('prod') ||
    host.includes('butlerbrief.com') ||
    host.includes('bbf-web-gu9k.onrender.com'); // your prod preview

  const baseUrl = isProd
    ? 'https://render-send-email.onrender.com'
    : 'https://render-send-email-dev.onrender.com';

  const p = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${p}`;
};
